import { useContext, useState } from 'react';
import { Badge, Button, Card, Center, Divider, Grid, Group, List, LoadingOverlay, ScrollArea, Stack, Text, TextInput } from '@mantine/core';
import { AlertNotification } from '../../shared/AlertNotification';
import AppContext from '../../shared/AppContext';
import { Brief } from '../ProcessNeed/brief';
import { useTranslation } from 'react-i18next';

const AddNeed = () => {

    const myContext = useContext(AppContext);
  const { t } = useTranslation();
    
    const [clientName, setClientName] = useState('');
    const [clientMission, setClientMission] = useState('');
    const [clientDuration, setClientDuration] = useState('');
    const [clientLocalisation, setClientLocalisation] = useState('');
    const [needId, setNeedId] = useState<number | null>(null);
    const [isWaiting, setIsWaiting] = useState(false);
    
    const createNeed = () => {
        if (clientName.trim() === '') return;
        if (clientMission.trim() === '') return;
        setIsWaiting(true);
        const F = new FormData();
        F.append('client_name', clientName.trim());
        F.append('client_mission', clientMission.trim());
        if (clientDuration.trim() !== '') {
            F.append('client_duration', clientDuration.trim());
        }
        if (clientLocalisation.trim() !== '') {
            F.append('client_localisation', clientLocalisation.trim());
        }
        const api = myContext.apiAddress + '/create_need';
        myContext.httpClient.post(api, F).then((res:any) => {
            if (res.data.status === true) {
                setNeedId(res.data.data.id);
            } else {
                AlertNotification({message: res.data.message || 'unknown error in saving'})
            }
            setIsWaiting(false);
        });
    }

    return (
        <Grid>
            <Grid.Col md={12} lg={7}>
            {needId === null ?
                <Center>
                    <Card>
                        <LoadingOverlay visible={isWaiting} />
                        <TextInput
                            label={t("need.clientName")}
                            value={clientName} 
                            onChange={(event) => setClientName(event.currentTarget.value)}
                            withAsterisk
                        />
                        <TextInput
                            label={t('need.libelleDuPosteDeLa')}
                            value={clientMission} 
                            onChange={(event) => setClientMission(event.currentTarget.value)}
                            withAsterisk
                        />
                        <TextInput
                            label={t('need.dureePrevisionnelleDeLaMission')}
                            value={clientDuration} 
                            onChange={(event) => setClientDuration(event.currentTarget.value)}
                        />
                        <TextInput
                            label={t("need.missionLocation")}
                            value={clientLocalisation} 
                            onChange={(event) => setClientLocalisation(event.currentTarget.value)}
                        />
                        <Center mt="xs">
                            <Button color="blue" variant="outline" onClick={() => createNeed()}
                                disabled={clientName.trim() === '' || clientMission.trim() === ''}
                            >
                                {t('need.createThisNeed')}
                            </Button>
                        </Center>
                    </Card>    
                </Center>
            :
                <ScrollArea style={{height: 'calc(100vh - 90px)'}} pb='lg'>
                    <Group>
                        <Text>{t('need.creationDeLaMission')}</Text><Badge>{needId}</Badge>
                    </Group>
                    <Brief needId={needId} isOpen={true} handleLabel={null} />
                </ScrollArea>
            }
            </Grid.Col>
            <Grid.Col md={12} lg={5}>
                <ScrollArea style={{height: 'calc(100vh - 90px)'}}>
                    <Stack>
                        <Divider label={t("need.whoAreWe")} labelPosition='center'/>
                        <List style={{fontSize: '0.8em', width: '95%'}}>
                            <List.Item>{t('need.nousSommesUnCabinetImplante')}</List.Item>
                            <List.Item>{t("need.briefPool")}</List.Item>
                            <List.Item>{t("need.briefFunctions")}</List.Item>
                            <List.Item>{t("need.briefSectors")} : industrie, retail, services (adapter le discours en fonction de l’activité de l’entreprise).</List.Item>
                            <List.Item>{t('need.actuellementNousAvonsAPeu')}</List.Item>
                        </List>
                        <Divider label={t("need.context")} labelPosition='center'/>
                        <List style={{fontSize: '0.8em', width: '95%'}}>
                            <List.Item>{t("need.companyActivity")}</List.Item>
                            <List.Item>Fonction du contact de l’entreprise</List.Item>
                            <List.Item>Chiffre d’Affaires</List.Item>
                            <List.Item>{t("need.companySize")}</List.Item>
                            <List.Item>{t('need.localisation')}</List.Item>
                        </List>
                        <Divider label={t("need.missionSection")} labelPosition='center'/>
                        <List style={{fontSize: '0.8em', width: '95%'}}>
                            <List.Item>{t("need.managerFunction")}</List.Item>
                            <List.Item>{t("need.missionFramework")}</List.Item>
                            <List.Item>{t('need.missionsClesDuManagerActions')}</List.Item>
                            <List.Item>{t("need.teamToManage")}</List.Item>
                            <List.Item>{t('need.aQuiLeManagerEstil')}</List.Item>
                            <List.Item>{t('need.yAtilUneFicheDe')}</List.Item>
                            <List.Item>{t('need.dateDeDemarrage')}</List.Item>
                            <List.Item>{t("need.expectedDuration")} ? Il est plus facile d’attirer les talents pour des missions de 6 mois</List.Item>
                            <List.Item>{t("need.remoteWork")}</List.Item>
                            <List.Item>{t("need.multiSiteTravel")}</List.Item>
                        </List>
                        <Divider label={t('need.manager')} labelPosition='center'/>
                        <List style={{fontSize: '0.8em', width: '95%'}}>
                            <List.Item>{t('need.quelsSoftskillsQualitesRelationnellesSont')}</List.Item>
                            <List.Item>{t("need.sameSector")} d’activité que l’entreprise cliente ?</List.Item>
                            <List.Item>{t('need.outilsSpecifiqueAMaitriser')}</List.Item>
                            <List.Item>{t('need.langueAMaitriser')}</List.Item>
                        </List>
                    </Stack>
                </ScrollArea>
            </Grid.Col>
        </Grid>
    )

}

export { AddNeed }